export default __webpack_public_path__ + "static/media/Jetpack.256.3ead5576.png";